import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/heroImage.png'


const _withScopeId = n => (_pushScopeId("data-v-d0b1d344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { style: {"min-height":"100vh","background":"linear-gradient(90deg, #3d099b 80%, #72FFFF 20%)"} }
const _hoisted_3 = {
  class: "home__section",
  ref: "homeHero"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"home__hero\" data-v-d0b1d344><div class=\"home__hero__content fadein-up\" data-v-d0b1d344><h1 aria-label=\"Frontend Engineer\" data-v-d0b1d344> Frontend <br data-v-d0b1d344> Engineer<span data-v-d0b1d344>.</span></h1><p data-v-d0b1d344>I like to make things, especially those that work on computers and on the web.</p><div data-v-d0b1d344><ul data-v-d0b1d344><li data-v-d0b1d344>Highly skilled with web performance, accessibility &amp; UI Engineering</li><li data-v-d0b1d344>Approach engineering with usability and user experience as core building block.</li></ul></div></div><div class=\"fadein-left\" data-v-d0b1d344><img id=\"micheal_adisa\" class=\"header__logo\" src=\"" + _imports_0 + "\" alt=\"Micheal Adisa\" accesskey=\"micheal_adisa\" data-v-d0b1d344></div></div>", 1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "home__stack",
  id: "stack",
  ref: "stack"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div data-v-d0b1d344><div class=\"home__stack__first container fadein-up\" data-v-d0b1d344><div class=\"shake\" data-v-d0b1d344> . </div><div data-v-d0b1d344><h2 aria-label=\"Design\" data-v-d0b1d344>Design.</h2><p data-v-d0b1d344> Frequent times i find myself putting texts and shapes together to born out a pleasing UI like the one you are going through right now. I utilize tools like Figma, Adobe XD and Corel draw for various design crafting and manipulation. </p></div></div><div class=\"home__stack__first container\" data-v-d0b1d344><div data-v-d0b1d344><h2 aria-label=\"Development\" data-v-d0b1d344>Development.</h2><p data-v-d0b1d344> In building applications, i utilize but not limited to tools like Javascript, Typescript, VueJs, ReactJs, NodeJs, SCSS, Python among others. I can absolutely function independently and deliver fast, resilient solutions optimized for scale with performance, usability and scalabilty as the building blocks. </p></div><div class=\"shake\" data-v-d0b1d344> . </div></div></div>", 1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "home__testimonial" }
const _hoisted_10 = { class: "home__testimonial--container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("blockquote", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "quote__quote-mark"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.928,3.932A9.709,9.709,0,0,0,.5,13.88v1.243a4.942,4.942,0,1,0,4.941-4.941,4.609,4.609,0,0,0-1.115.14.25.25,0,0,1-.277-.368A6.832,6.832,0,0,1,9.928,6.432a1.25,1.25,0,0,0,0-2.5Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M22.25,6.432a1.25,1.25,0,0,0,0-2.5,9.71,9.71,0,0,0-9.428,9.948v1.243a4.942,4.942,0,1,0,4.942-4.941,4.611,4.611,0,0,0-1.116.14.249.249,0,0,1-.26-.092.252.252,0,0,1-.017-.276A6.832,6.832,0,0,1,22.25,6.432Z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Working with Micheal was an exceptional experience. I can’t say enough great things about his thought process, workflow, deligence and the quality of his code. He is a talented developer who knows his onions.")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Fatoki Oladele", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "CEO, Uptima", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("See Case Study")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_ContactSuccess = _resolveComponent("ContactSuccess")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderComponent, {
          class: "navbar",
          ref: "home"
        }, null, 512),
        _createElementVNode("section", _hoisted_3, _hoisted_5, 512)
      ]),
      _createElementVNode("section", _hoisted_6, _hoisted_8, 512),
      _createVNode(_component_ContactSuccess),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("figure", null, [
            _hoisted_11,
            _createElementVNode("figcaption", null, [
              _createElementVNode("div", null, [
                _hoisted_12,
                _hoisted_13,
                _createVNode(_component_router_link, { to: "/portfolio/uptima" }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}